import { useQuery, useMutation } from "react-query";
import {
	add_coupons_api,
	delete_coupons_api,
	get_all_coupons_api,
	update_coupons_api,
	get_restaurant_stripe_status_api,
	get_coupons_byId_api,
} from "../services/coupons";

export const usegetAllCoupons = (payload) =>
	useQuery(["getAllCoupons", payload], () => get_all_coupons_api(payload));

export const usegetRestaurantStatus = (params) =>
	useQuery(["getRestaurantStatus", params], () =>
		get_restaurant_stripe_status_api(params)
	);

export const useaddCoupons = () =>
	useMutation("addcoupons", (body) => add_coupons_api(body));

export const useupdateCoupons = () =>
	useMutation("updatecoupons", (body) => update_coupons_api(body));

export const usedeleteCoupons = () =>
	useMutation("deletecoupons", (body) => delete_coupons_api(body));

export const useGetCouponsByID = (payload, makeCall) =>
	useQuery(
		["couponsById", payload],
		() => get_coupons_byId_api(payload),
		makeCall
	);
